import { render, staticRenderFns } from "./TopazRead.vue?vue&type=template&id=9b1e976a&"
import script from "./TopazRead.vue?vue&type=script&lang=js&"
export * from "./TopazRead.vue?vue&type=script&lang=js&"
import style0 from "./TopazRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports